import { z } from "zod";

export const certificateCaptured = z.object({
  type: z.literal("CertificateCaptured"),
  certificateId: z.string().min(1),
  userId: z.string().min(1),
  documentKey: z.string().min(1),
  mime: z.string().min(1),
});

export const certificateOcrCompleted = z.object({
  type: z.literal("CertificateOcrCompleted"),
  certificateId: z.string().min(1),
  rawText: z.string(),
  ocrModel: z.string(),
});

// `fields`/`structured`/`validation` mirror lib/ocr.ts CertificateProcessingResult.
export const certificateParsed = z.object({
  type: z.literal("CertificateParsed"),
  certificateId: z.string().min(1),
  fields: z.record(z.string(), z.unknown()),
  structured: z.record(z.string(), z.unknown()).nullable().optional(),
  validation: z.record(z.string(), z.unknown()),
  parserModel: z.string(),
  photoDetected: z.boolean().optional(),
  photoConfidence: z.number().nullable().optional(),
});

export const certificateProcessingFailed = z.object({
  type: z.literal("CertificateProcessingFailed"),
  certificateId: z.string().min(1),
  error: z.string(),
});

export const certificateApproved = z.object({
  type: z.literal("CertificateApproved"),
  certificateId: z.string().min(1),
});

export const certificateRejected = z.object({
  type: z.literal("CertificateRejected"),
  certificateId: z.string().min(1),
  reason: z.string().optional(),
});

export const certificateDeleted = z.object({
  type: z.literal("CertificateDeleted"),
  certificateId: z.string().min(1),
});

export const certificateEvents = [
  certificateCaptured,
  certificateOcrCompleted,
  certificateParsed,
  certificateProcessingFailed,
  certificateApproved,
  certificateRejected,
  certificateDeleted,
] as const;
